"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const constants_1 = require("./helpers/constants");
const context_1 = require("src/context/context");
const OverlayTooltip_1 = tslib_1.__importDefault(require("core/components/OverlayTooltip"));
const MediaFileOnlyName = (props) => {
    const { toast } = (0, context_1.useToastContext)();
    return ((0, jsx_runtime_1.jsx)("div", { children: props.files.map(file => {
            return ((0, jsx_runtime_1.jsxs)("div", { className: 'pb-1 ml-2', children: [(0, jsx_runtime_1.jsx)("span", { style: { cursor: (props.isFacsimile
                                ? constants_1.allowedZoomExtensions.find(item => item === file.extension)
                                : constants_1.fileExtensions.find(item => item.extension === file.extension && !item.allowDownload))
                                ? 'zoom-in'
                                : 'not-allowed'
                        }, onClick: async (e) => {
                            if (!props.hook.isGettingFileProperties.includes(file.id)) {
                                e.preventDefault();
                                props.hook.handleOpenFile(file, props.isFacsimile);
                            }
                        }, children: file.originalName.length > 55
                            ?
                                (0, jsx_runtime_1.jsx)(OverlayTooltip_1.default, { content: file.originalName, children: (0, jsx_runtime_1.jsxs)("span", { children: [file.originalName.substring(0, 55), "..."] }) })
                            : file.originalName }), file && props.hook.isGettingFileProperties.includes(file.id)
                        ? (0, jsx_runtime_1.jsx)("span", { className: 'spinner-grow spinner-grow-sm' })
                        : null, !props.isFacsimile
                        ? (0, jsx_runtime_1.jsx)("i", { className: `fas text-primary ml-3${props.hook.loadingFileIds.includes(file.id) ? ' mb-1 spinner ' : ' fa-file-download pointer'}`, onClick: async () => {
                                const res = await props.hook.downloadFile(file.id);
                                if (res.errors !== null)
                                    res.errors.forEach(el => toast.danger(el.message));
                            } })
                        : null] }, file.id));
        }) }));
};
exports.default = MediaFileOnlyName;
